import React from 'react';
import { storiesOf } from '@storybook/react';
import AttorneysResultRow from './AttorneysResultRow';
import { RowHeader } from '../EntriesResults';

storiesOf('Advanced Search/Result Rows', module)
  .add('Attorneys', () => (
    <div className="result-item">
      <RowHeader row={row} />
      <div className="result-item-body">
        <AttorneysResultRow row={row} />
      </div>
    </div>
  ));

const row = {
  associated: [
    {
      address: "401 Broadhollow Road↵Melville, NY 11747",
      email: null,
      fax: null,
      name: '<span class="highlight">Sbarro</span> LLC',
      phone: null,
      role: "Debtor",
    },
    {
      address: "401 Broadhollow Road↵Melville, NY 11747",
      email: null,
      fax: null,
      name: '<span class="highlight">Sbarro</span> LLC',
      phone: null,
      role: "Joint Debtor",
    },
    {
      address: "401 Broadhollow Road↵Melville, NY 11747",
      email: null,
      fax: null,
      name: '<span class="highlight">Sbarro</span> LLC,  <I>Debtor</I>',
      phone: null,
      role: "Debtor",
    },
    {
      address: "401 Broadhollow Road↵Melville, NY 11747",
      email: null,
      fax: null,
      name: '<span class="highlight">Sbarro</span> LLC,  <I>et al.</I>',
      phone: null,
      role: "Debtor",
    }],
  attorney: {
    address: "Kirkland & Ellis, LLP↵601 Lexington Avenue↵New York, NY 10022",
    assigned_date: null,
    case_attorney_id: 87066,
    email: "ngreenblatt@kirkland.com",
    fax: "(212) 446-4900",
    lead: "Attorney",
    modified: "2014-03-10 13:01:50.412383+00",
    name: "Nicole Greenblatt",
    phone: "(212) 446-4800",
  },
  case: {jurisdiction: null, case_no: "1:14-bk-10557", date_discharged: null},
  case_assets: "Unknown",
  case_chapter: 11,
  case_court: "nysbke",
  case_date_filed: "03/10/2014",
  case_judge_name: "Martin Glenn",
  case_liabilities: "Unknown",
  case_naics_code: null,
  case_nature_of_suit_code: null,
  case_no: "1:14-bk-10557",
  case_title: "Sbarro LLC",
  case_type: "bk",
  case_uuid: "nysbke_247775",
  date_filed: "08/29/2019",
  document_type: "attorneys",
};


// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/AttorneysResultRow.stories.jsx